export default "__VITE_ASSET__4zdnwyDt__"